import { useCallback, useMemo } from "react";
import useFeature from "hooks/useFeature";
import useWidgetUnits from "views/components/visualizations/hooks/useWidgetUnits";
import {
  generateMappersForYAxis,
  getHoverTemplateSettings
} from "views/components/visualizations/utils/chartLayoutGenerators";
import convertDataToBaseUnit from "views/components/visualizations/utils/convertDataToBaseUnit";
import { NO_FIELD_NAME_SERIES, UNIT_FEATURE_FLAG } from "views/components/visualizations/Constants";
import { getBaseUnit } from "views/components/visualizations/utils/unitConverters";
import FieldUnit from "views/logic/aggregationbuilder/FieldUnit";
import isLayoutRequiresBaseUnit from "views/components/visualizations/utils/isLayoutRequiresBaseUnit";
import getFieldNameFromTrace from "views/components/visualizations/utils/getFieldNameFromTrace";
const useChartDataSettingsWithCustomUnits = ({ config }) => {
  const unitFeatureEnabled = useFeature(UNIT_FEATURE_FLAG);
  const widgetUnits = useWidgetUnits(config);
  const { fieldNameToAxisNameMapper } = useMemo(
    () => generateMappersForYAxis({ series: config.series, units: widgetUnits }),
    [config.series, widgetUnits]
  );
  return useCallback(
    ({ name, values, fullPath }) => {
      var _a;
      if (!unitFeatureEnabled) return {};
      const fieldNameKey = (_a = getFieldNameFromTrace({ fullPath, series: config.series })) != null ? _a : NO_FIELD_NAME_SERIES;
      const yaxis = fieldNameToAxisNameMapper[fieldNameKey];
      const curUnit = widgetUnits.getFieldUnit(fieldNameKey);
      const shouldConvertToBaseUnit = isLayoutRequiresBaseUnit(curUnit);
      const convertedValues = shouldConvertToBaseUnit ? convertDataToBaseUnit(values, curUnit) : values;
      const baseUnit = shouldConvertToBaseUnit && getBaseUnit(curUnit == null ? void 0 : curUnit.unitType);
      const unit = shouldConvertToBaseUnit ? new FieldUnit(baseUnit == null ? void 0 : baseUnit.unitType, baseUnit == null ? void 0 : baseUnit.abbrev) : curUnit;
      return {
        yaxis,
        y: convertedValues,
        fullPath,
        ...getHoverTemplateSettings({ unit, convertedValues, name })
      };
    },
    [config.series, fieldNameToAxisNameMapper, unitFeatureEnabled, widgetUnits]
  );
};
export default useChartDataSettingsWithCustomUnits;
